import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Logger } from '../logger/logger.service';
import { ILoginRequest, ILoginResponse } from 'src/app/models/login-request';
import { IForgotPassword } from 'src/app/models/forgot-pwd';
import { IApiResponse } from 'src/app/models/api-response';
import { IResetPassword } from 'src/app/models/reset-pwd';
import { IMyProfile } from 'src/app/models/user-profile';
import { IAgreeTermsResponse } from 'src/app/models/agree-terms-response';

const logger = new Logger('LoginService');
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private apiUrl = {
    login : environment.baseUrl + 'login',
    resetPwd: environment.baseUrl + 'reset-password',
    register:environment.baseUrl + 'register',
    logout: environment.baseUrl+ 'logout',
    forgotPwd: environment.baseUrl + 'forgot-password',
    refreshToken: environment.baseUrl + 'refresh-token',
    getMyProfile: environment.baseUrl+ 'my/info',
    agreeTerms: environment.baseUrl + 'terms/agree'
  };

  public redirectUrl : string | null= null;

  private timezoneMap: { [key: string]: string } = {
    "Asia/Calcutta": "Asia/Kolkata",
    "US/Eastern": "America/New_York",
    "US/Central": "America/Chicago",
    "US/Mountain": "America/Denver",
    "Europe/Paris": "Europe/Brussels",
    "Europe/Lisbon": "Europe/Luxembourg",
    "Australia/Adelaide": "Australia/Sydney",
    "Europe/Prague": "Europe/Vienna",
    "Asia/Seoul": "Asia/Chongqing", 
  };

  constructor(private httpClient: HttpClient) {
 
  }

   public login(login: ILoginRequest): Observable<ILoginResponse> {
    logger.info('Login API Called');
    return this.httpClient.post<ILoginResponse>(this.apiUrl.login, login);
  }

  public forgotPwd(data: IForgotPassword): Observable<IApiResponse> {
    logger.info('Forgot Password API Called');
    return this.httpClient.post<any>(this.apiUrl.forgotPwd, data);
  }

  public logout() : Observable<IApiResponse> {
    logger.info("Logout API called");
    return this.httpClient.get<IApiResponse>(this.apiUrl.logout);
  }

  public resetPwd(request: IResetPassword): Observable<IApiResponse> {
    logger.info("Reset Password API called");
    return this.httpClient.post<IApiResponse>(this.apiUrl.resetPwd, request);
  }
  
  public refreshToken() : Observable<ILoginResponse>  {
    logger.info("Refresh Token API called");
    return this.httpClient.get<ILoginResponse>(this.apiUrl.refreshToken);
  }
  public getMyProfile() : Observable<IMyProfile>  {
    logger.info("Get My profile API called");
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    timezone = this.timezoneMap[timezone] || timezone;
    return this.httpClient.get<IMyProfile>(this.apiUrl.getMyProfile,
        {params : { 'timezone' : timezone}});
  }

  public isUserLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    return token ? true : false;
  }


  public agreeTermsOfUse(): Observable<IAgreeTermsResponse>{
    return this.httpClient.post<IAgreeTermsResponse>(this.apiUrl.agreeTerms, {
      "agree": true
    });
  }

}

